import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import generateContentDataObject from "../../../../helpers/editor/generateContentDataObject";
import DebouncedTextarea from "../../../DebouncedTextarea";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  item: any;
  saveContentInStore: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  keyProp: number;
  toggleNewEditionsDetected: (value: boolean) => void;
}

const GalleryTabSubtitle = (props: Props): JSX.Element => {
  const {
    item,
    saveContentInStore,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const generator = new generateContentDataObject();

  let onChangeGalleryTabSubtitleHandler = (value: any) => {
    saveContentInStore(
      generator.changeGalleryTabSubtitle(
        { [contentType]: currentInputDataRef.current },
        keyProp,
        value
      )
    );
    toggleNewEditionsDetected(true);
  };

  if (!currentInputDataRef.current.tabHasSubtitle) return null;

  return (
    <DebouncedTextarea
      className="content-input__input"
      onChange={onChangeGalleryTabSubtitleHandler}
      defaultValue={item.tabSubtitle}
      autosize={{ minRows: 1, maxRows: 2 }}
      placeholder="Add tab subtitle"
    />
  );
};

export default GalleryTabSubtitle;
